import { cn } from '~/utils/cn';

import { DIFF_STATUS_BACKGROUND_CLASS, type DiffStatus } from './diff-status.util';

interface DiffCellProps {
  status: DiffStatus;
  children: React.ReactNode;
  className?: string;
  /** Automation hook; defaults to `diff-cell-{status}` so QA can assert the diff outcome. */
  testId?: string;
}

/** Wraps existing cell content with the background color matching its diff status, per `DiffLegend`. */
export function DiffCell({ status, children, className, testId }: DiffCellProps) {
  return (
    <div
      className={cn('rounded-md p-1.5', DIFF_STATUS_BACKGROUND_CLASS[status], className)}
      data-testid={testId ?? `diff-cell-${status}`}
    >
      {children}
    </div>
  );
}
